import React from 'react';
import './ResortInfo.scss';

const ResortInfo = () => {
  	return (
		<div className="resortInfo">
            <h1>Resort Info</h1> 
            <iframe 
                title="resortInfo"
                height="600" 
                width="100%" 
                src="https://www.youtube.com/embed/3tGEllBlNpo" 
                frameBorder="0" 
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
            >
            </iframe>
            <div>
                <a href="https://encorereunion.com">Encore Resort at Reunion</a>
                <p>What’s Unique About Encore Resort at Reunion?</p>
                <p>
                    Encore Resort at Reunion is the first of its kind in vacation home rentals. A private resort community near Disney in Orlando,
                    Encore elevates the vacation rental experience by bridging the gap between hotel and peer-to-peer lodging.
                    Accommodation is complemented by guest-oriented services and an outstanding range of amenities. Featuring a variety of
                    3-13-bedroom homes, guests enjoy the affordability of a vacation rental, plus all the added perks you would expect from a luxury resort.
                </p>
            </div>
		</div>
  	);
}

export default ResortInfo;